import { css } from 'styled-components';

export const inlineBlockFormItem = css`
  display: inline-block;
  width: auto;
  margin-right: var(--space-4);
`;
